var map = {
	"./dropdown-review": 50841,
	"./free-text-review": 24039,
	"./multi-select-review": 60005,
	"./paragraph-text-review": 8732,
	"./section-break-review": 77634,
	"./section-header-review": 73758,
	"./short-answer-review": 3638,
	"./single-select-review": 98439,
	"./text-fields-review": 64774
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86082;